import React from 'react';

import Loader from '../../../common/components/notifications/Loader';
import ListingPreferenceEditor from './ListingPreferenceEditor';

class ListingController extends React.Component {
    constructor (props) {
        super(props)
        this.state = this.props.store();
    }

    componentWillMount () {
        var self = this;
        this.removeListener = this.props.store(function onChange (data) {
            self.setState(data);
        });
        this.props.actions.get();
    }

    componentWillUnmount () {
        this.removeListener();
    }

    render () {
        if (
            this.state.preference.isResolving ||
            this.state.metadata.categories.isResolving ||
            this.state.metadata.locations.isResolving ||
            this.state.metadata.keywords.isResolving ||
            this.state.metadata.assets.isResolving 
        ) return <Loader message="Fetching"/>;

        var { actions, onWorkspaceAction, preferenceID } = this.props;

        return <ListingPreferenceEditor
            preferenceID={preferenceID()}
            onWorkspaceAction={onWorkspaceAction}
            actions={actions}

            preference={this.state.preference.data.original}
            assets={this.state.metadata.assets.data}
            categories={this.state.metadata.categories.data}
            locations={this.state.metadata.locations.data}
            keywords={this.state.metadata.keywords.data}
        />;
    }
}

export default ListingController;
